import { useApi } from '@/shared/api/http';

export const useCategoriesService = () => {
  const api = useApi();

  const getCategories = async () => {
    return await api.get('activity-categories/');
  };

  const getCategoryBySlug = async (slug: string) => {
    return await api.get(`activity-categories/${slug}/`);
  };

  return {
    getCategories,
    getCategoryBySlug,
  };
};
